// extracted by mini-css-extract-plugin
export default {"cta":"DJ-z","disabled":"EJ-z"};